import { Routes } from '@angular/router';
export const DASHBOARD_ROUTES: Routes = [
  { path: 'dashboard', loadComponent: () => import('./pages/dashboard/dashboard.component').then((m) => m.DashboardComponent) },
];
